export const CONTAINER_CLASS = 'g2-crosshair';
export const CROSSHAIR_LINE = `${CONTAINER_CLASS}-line`;
export const CROSSHAIR_TEXT = `${CONTAINER_CLASS}-text`;
